import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Access <span>Top-Tier Mobile App</span> Development Prowess
            </h2>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Build My Custom App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-4 mt-md-0">
            <p>
              Access full-stack, enterprise-grade mobile app development
              services TekRevol. From immersive frontends to high-tech backends,
              we employ top talent and novel technologies to deliver compelling
              results. Every project our app development company deploys is
              responsive, highly fault-tolerant, and cyber-secure – in short, we
              build apps that are performant and loved by users.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Maximized API Integration</h6>
                <p>
                  Connect your app to existing systems with custom APIs,
                  enhancing functionality and efficiency.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalable Microservices Architecture</h6>
                <p>
                  Deploy microservices to ensure your app scales smoothly under
                  increasing user loads.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Robust Security Compliance</h6>
                <p>
                  Protect user data with encryption and biometric security,
                  meeting industry regulations.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>AI-Driven User Personalization</h6>
                <p>
                  Deliver personalized experiences with AI-driven content
                  recommendations.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Real-Time Monitoring</h6>
                <p>
                  Monitor app performance in real-time to optimize speed and
                  reliability.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Accelerated DevOps Pipelines</h6>
                <p>
                  Accelerate development with automated CI/CD pipelines for
                  faster releases.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
